import { render } from "./resultado.vue?vue&type=template&id=4fde0fa0&scoped=true"
import script from "./resultado.vue?vue&type=script&lang=js"
export * from "./resultado.vue?vue&type=script&lang=js"

import "./resultado.vue?vue&type=style&index=0&id=4fde0fa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fde0fa0"]])

export default __exports__